export default "__VITE_ASSET__vHWLR$S4__"